<template>
  <el-dialog
    :title="$t('personal::open-contract::cardManager')"
    :visible.sync="visible"
    width="690"
    :append-to-body="true"
  >
    <z-table :data="cards" :columns="cardColumns" :max-height="400" :pagination="false" v-loading="loading">
      <template #cardBrand="{ row }">
        <img style="height: 20px" :src="filterImg(row.cardBrand)" />
      </template>
      <template #cardNum="{ row }">
        <p class="card-number">
          <span v-for="i in 3" :key="i">****</span>
          <span>{{ row.cardNum }}</span>
        </p>
      </template>
      <template #operate="{ row }">
        <el-button type="text" @click="unBind(row)" style="color: red">{{ $t('personal::contract::解绑') }}</el-button>
        <el-button type="text" @click="setPayCard(row)" v-if="!row.defaulted">
          {{ $t('personal::contract::setPayCard') }}
        </el-button>
      </template>
    </z-table>
    <addCard v-model="addVisible" @success="$emit('success')"></addCard>
  </el-dialog>
</template>

<script>
import { cardColumns, filterImg } from '../config'
import { setCardDefault, deleteCard } from '@/server/personal/contract'
import AddCard from './addCard.vue'
export default {
  components: { AddCard },
  props: {
    value: {},
    cards: {
      default: () => [],
    },
  },
  data() {
    return {
      cardColumns,
      visible: false,
      loading: false,
      addVisible: false,
    }
  },
  methods: {
    filterImg,
    // 设置支付卡
    async setPayCard(row) {
      this.$confirm(this.$t('personal::contract::setPayCard-tips'), this.$t('personal::contract::提示'), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.loading = true
          const { data } = await setCardDefault({
            id: row.id,
            cardNum: row.cardNum,
          })
          this.loading = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('personal::contract::setPayCard-success'))
            this.$emit('success')
          }
        })
        .catch(() => {})
    },
    // 解绑
    async unBind(row) {
      if (this.cards.length < 2) {
        this.$confirm(this.$t('personal::contract::unbind-card-tips'), this.$t('personal::contract::提示'), {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
          type: 'warning',
        })
          .then(async () => {
            this.addVisible = true
          })
          .catch(() => {})
      } else {
        this.$confirm(this.$t('personal::contract::unbind-add-tips'), this.$t('personal::contract::提示'), {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
          type: 'warning',
        })
          .then(async () => {
            this.loading = true
            const { data } = await deleteCard(row.id)
            this.loading = false
            if (data.code === this.$code) {
              this.$message.success(this.$t('personal::contract::解绑成功'))
              this.$emit('success')
            }
          })
          .catch(() => {})
      }
    },
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped lang="scss">
.card-number {
  letter-spacing: 2px;
  color: #010517;
  font-size: 14px;
  span {
    margin-right: 8px;
  }
}
</style>
